/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import './style/firstImport.scss';
import React, {MouseEventHandler} from 'react';

import {useTranslation} from 'react-i18next';

interface Props {
    onClose: MouseEventHandler;
    active: boolean;
    position: {x: number; y: number};
}

export default function FirstImport(props: Props) {
    const {t} = useTranslation();
    const {active, onClose, position} = props;

    if (!active) return null;
    return (
        <>
            <div className='first-import-background' />
            <div className='first-import' style={{left: `${position.x}px`, top: `${position.y}px`}}>
                <p className='message'>
                    {t(
                        'dashboard.firstImport.message',
                        'We hebben de oudere order voor je opgezocht en deze toegevoegd aan je account. Deze order is geplaatst voordat je een Bolmate account ingesteld hebt, hierdoor kunnen wij niet automatisch het factuurnummer bepalen. Klik op de order en kies de optie "Factuurnummer instellen" om zelf een factuurnummer te kiezen.'
                    )}
                </p>
                <label className='close-btn' onClick={onClose}>
                    {t('dashboard.firstImport.understood', 'Begrepen')}
                </label>
            </div>
        </>
    );
}
